<template>
  <div class="flex flex-col gap-3">
    <h3 class="m-0 text-sm font-semibold text-foreground">{{ label }}</h3>
    <div v-if="postTypes.length > 1" class="flex flex-col gap-1.5">
      <ui-label>{{ tr('Post type') }}</ui-label>
      <checkbox-list
        v-model="entity[postTypeProperty]"
        :options="postTypeOptions"
      />
    </div>

    <div v-if="postMediaTypes.length > 1" class="flex flex-col gap-1.5">
      <ui-label>{{ tr('Media type') }}</ui-label>
      <checkbox-list
        v-model="entity[postMediaTypeProperty]"
        :options="mediaTypeOptions"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import CheckboxList from '@/ui/components/CheckboxList.vue';

export default {
  name: 'PostTypeSelector',
  components: {
    CheckboxList,
  },
  props: {
    platform: {
      type: String,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    postTypes() {
      return this.$store.getters['app/' + this.platform + 'PostTypes'];
    },
    postMediaTypes() {
      return this.$store.getters['app/' + this.platform + 'PostMediaTypes'];
    },
    // Only reels is locked in a disabled form, as before.
    postTypeOptions() {
      return this.postTypes.map(postType => ({
        value: postType.machine_name,
        label: this.tr(postType.label),
        disabled: this.disabled && postType.machine_name === 'reels',
      }));
    },
    mediaTypeOptions() {
      return this.postMediaTypes
        .filter(mediaType => this.mediaTypeIsAvailabe(mediaType))
        .map(mediaType => ({ value: mediaType.machine_name, label: this.tr(mediaType.label) }));
    },
    postTypeProperty() {
      return this.platform + '_post_types';
    },
    postMediaTypeProperty() {
      return this.platform + '_post_media_types';
    },
    albumMediaTypeIsAvailable() {
      return this.entity[this.postTypeProperty].includes('feed');
    },
    nonVideoTypesAreAvailable() {
      return this.entity[this.postTypeProperty].includes('feed');
    },
    label() {
      return this.platform.charAt(0).toUpperCase() + this.platform.slice(1);
    },
  },
  watch: {
    albumMediaTypeIsAvailable(val) {
      if (!val) {
        this.entity[this.postMediaTypeProperty] = this.entity[this.postMediaTypeProperty].filter(item => item !== 'album');
      }
    },
    nonVideoTypesAreAvailable(val) {
      if (!val) {
        this.entity[this.postMediaTypeProperty] = this.entity[this.postMediaTypeProperty].filter(item => item === 'video');
      }
    },
  },
  methods: {
    selectAll() {
      let newPostTypes = this.postTypes.map(item => item.machine_name);
      if (this.platform === 'facebook' && this.entity.action === 'start') {
        newPostTypes = newPostTypes.filter(item => item !== 'reels');
      }

      this.entity[this.postTypeProperty] = newPostTypes;
      this.entity[this.postMediaTypeProperty] = this.postMediaTypes.map(item => item.machine_name);
    },
    mediaTypeIsAvailabe(mediaType) {
      if (!this.nonVideoTypesAreAvailable && mediaType.machine_name !== 'video') {
        return false;
      }

      if (!this.albumMediaTypeIsAvailable && mediaType.machine_name === 'album') {
        return false;
      }

      return true;
    },
  },
};
</script>
